module.exports = __webpack_public_path__ + "img/silver4.e477b2f6.png";